var exports = {
  "kL": "xa15a2ab7--d96799--container",
  "Qs": "xa15a2ab7--d96799--content",
  "Fp": "xa15a2ab7--d96799--link-container",
  "WN": "xa15a2ab7--d96799--popup_link",
  "W1": "xa15a2ab7--d96799--title_link",
  "GM": "xa15a2ab7--d96799--input_link",
  "Jk": "xa15a2ab7--d96799--copy_link",
};

module.exports = exports;
